<template>
  <div class="flex flex-column flex-grow-1 gap-4">
    <label class="label-top">{{ Demographic.humanAttributeName('identity_type') }}</label>
    <div v-if="selectable" class="flex p-float-label">
      <Dropdown
        v-model="identity_type"
        :options="identityTypeList"
        optionLabel="title"
        optionValue="value"
        placeholder="Select an Identity Type"
        inputId="identity_type"
        class="flex-grow-1 identity-number-input"
      />
      <label class="label-border">{{ Demographic.humanAttributeName('identity_type') }}</label>
    </div>

    <div class="flex flex-column gap-2">
      <label class="label-top">{{ props.label }}</label>
      <div class="flex p-float-label">
        <InputText v-model="identity_number" v-bind="$attrs" class="flex-grow-1 identity-number-input" />
        <label class="label-border">{{ props.label }}</label>
      </div>
      <div class="flex flex-row-reverse justify-content-between">
        <small id="nin_number-help">{{ value ? value.length : 0 }}/{{ ninLength }}</small>
        <small v-if="v$.value.$error" id="nin_number-help" class="p-error">Invalid NIN</small>
        <small v-if="v$.value.$error == [] && props.required" id="nin_number-help" class="help-text"
          >*{{ t('general.required') }}</small
        >
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, maxLength, minLength, alphaNum, helpers } from '@vuelidate/validators'
import Demographic from '@/models/Demographic.js'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'

const identity_number = defineModel('identity_number')
const identity_type = defineModel('identity_type')
// const emit = defineEmits(['identityTypeChange'])
const props = defineProps({
  modelValue: String,
  label: {
    type: String,
    required: true
  },
  selectable: {
    type: Boolean,
    required: true
  },
  defaultType: {
    type: String,
    required: false
  },
  identityTypeList: {
    type: Array,
    required: false
  },
  country_code: {
    type: String,
    required: true,
    default: 'ZA'
  },
  include_none: {
    type: Boolean,
    required: false,
    default: false
  },
  required: {
    type: Boolean,
    required: false,
    default: true
  }
})

const { t } = useI18nUtils()

const ninLength = computed(() => {
  let r = 20
  if (props.country_code == null) {
    return 20
  }
  if (props.country_code === 'BW') {
    r = 9
  }
  if (props.country_code === 'KE') {
    r = 8
  }
  if (props.country_code === 'TZ') {
    r = 20
  }
  if (props.country_code === 'UG') {
    r = 14
  }
  if (props.country_code === 'ZA') {
    r = 13
  }
  return r
})
const value = computed(() => identity_number.value)

const startsWithCMCF = (value) =>
  !helpers.req(value) || value.startsWith('CM') || value.startsWith('CF')

const rules = computed(() => {
  let v = {}
  v.value = { required }
  if (props.country_code && props.country_code === 'UG') {
    v.value = {
      required,
      alphaNum,
      maxLength: maxLength(14),
      minLength: minLength(14),
      startsWithCMCF
    }
  }
  return v
})

const v$ = useVuelidate(rules, { value })
// watch(identityType, () => {
//   emit('identityTypeChange', identityType.value.value)
// })
</script>

<style scoped>
.identity-number-input {
  height: 40px;
  box-shadow: 1px 2px 4px #00000029;
  border: 0.5px solid #E5E5E5;
  border-radius: 8px;
}

label {
  font-weight: 550;
  color: #013315;
}

.label-top {
  margin-bottom: 8px;
  display: none;
}

@media screen and (min-width: 768px) {
  .label-top {
    display: block;
  }

  .label-border {
    display: none;
  }
}

</style>
